<template>
  <MainLayout>
    <div class="container mt-2 mb-4">
      <div v-html="data"></div>
    </div>
  </MainLayout>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useConstantStore } from "~~/store/constant";
import { ConstantKey } from "~/contract/enum/ConstantRelated.enum";
import MainLayout from "~/layout/layouts/index.vue";

const constantStore = useConstantStore();
const data = ref<any>("");
onMounted(() =>
  nextTick(async () => {
    data.value = await constantStore.getConstant(ConstantKey.COMPANY_ABOUT);
  })
);
</script>

<style lang="scss" scoped></style>
